<template>
    <th
        @mouseover="hovered=true"
        @mouseout="hovered=false"
        @click="click"
    >
        <span v-html="label"></span>
        <open-icon
            v-if="sort !== false"
            :glyph="glyph"
            :class="{ 'uk-active': !!sort || hovered, 'uk-text-muted': !sort && !hovered }"
            class="lam-table-sort uk-margin-small-left"
        />
    </th>
</template>

<script type="text/javascript">
import OpenIcon from "../OpenIcon"

export default {
    components: {
        OpenIcon
    },
    methods: {
        click () {
            this.$emit("click", this.field, (this.sort === "desc") ? "asc" : "desc")
        }
    },
    computed: {
        glyph () {
            if(this.hovered) {
                if(this.type === "plain") {
                    if(this.sort && this.sort.match(/^desc/i)) return "long-arrow-down"
                    return "long-arrow-up"
                }
                if(this.sort && this.sort.match(/^desc/i)) return `sort-${this.type}-asc`
                return `sort-${this.type}-desc`
            }
            if(this.type === "plain") {
                if(this.sort && this.sort.match(/^desc/i)) return "long-arrow-up"
                return "long-arrow-down"
            }
            if(this.sort && this.sort.match(/^desc/i)) return `sort-${this.type}-desc`
            return `sort-${this.type}-asc`
        }
    },
    props: {
        field: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        sort: {
            validator: prop => !prop || prop.match(/^(asc|desc)$/),
            required: true
        },
        type: {
            type: String,
            validator: prop => !!prop && prop.match(/^(amount|numeric|alpha|plain)$/),
            deafult: "amount"
        },
        compact: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            hovered: false
        }
    }
}
</script>
